import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import ColumnEnum from '@/global/components/DataGrid/utils/columEnum'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { DownloadIcon } from 'lucide-react'
import { BotaoEditar, BotaoExcluir } from './Opcoes'

export const columns: GridColDefPro[] = [
    {
        field: 'tipoAusencia',
        headerName: 'Tipo',
        minWidth: 140,
        type: new ColumnEnum([
            {
                value: 'Abono',
                label: 'Abono',
            },
            {
                value: 'Afastamento',
                label: 'Afastamento',
            },
            {
                value: 'Registro',
                label: 'Registro',
            },
            {
                value: 'Falta justificada',
                label: 'Falta justificada',
            },
            {
                value: 'Falta injustificada',
                label: 'Falta injustificada',
            },
        ]),
    },
    {
        field: 'Funcionario',
        headerName: 'Funcionário',
        minWidth: 200,
        flex: 1,
        valueGetter: ({ value }) => value.nome,
    },
    {
        field: 'ocorrencia',
        headerName: 'Ocorrência',
        minWidth: 100,
        flex: 1,
    },
    {
        field: 'justificativa',
        headerName: 'Justificativa',
        minWidth: 120,
        flex: 1,
    },
    {
        field: 'fielUrl',
        headerName: 'Anexo',
        width: 80,
        renderCell: params =>
            params.row.fileUrl ? (
                <IconButton
                    onClick={() => {
                        window.open(
                            `${import.meta.env.VITE_BASE_URL}/v1/uploads/${
                                params.row.fileUrl
                            }`,
                        )
                    }}
                    title="Baixar anexo"
                >
                    <DownloadIcon />
                </IconButton>
            ) : null,
    },
    {
        field: 'dataInicio',
        headerName: 'Data inicial',
        width: 130,
        type: 'date',
    },
    {
        field: 'dataFim',
        headerName: 'Data final',
        width: 130,
        type: 'date',
    },
    {
        ...optionsColumn,
        field: '__editar',
        renderCell: BotaoEditar,
    },
    {
        ...optionsColumn,
        field: '__excluir',
        renderCell: BotaoExcluir,
    },
]
